import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {OrbitLeaderboardEntry} from '@/model/resource/OrbitLeaderboardEntry'
import {OrbitLeaderboardSummary} from '@/model/resource/OrbitLeaderboardSummary'

@HttpExclude()
export class OrbitLeaderboardCollection extends ExpansibleCollection<
  OrbitLeaderboardEntry
> {
  @RequestExpose() limit: number | null = null
  @RequestExpose() page: number | null = null
  @RequestExpose() period: string | null = null
  @RequestExpose() orderBy: string | null = null
  @RequestExpose() ascending: boolean | null = null
  @RequestExpose() approvedOnly: boolean | null = null

  constructor() {
    super(OrbitLeaderboardEntry)
  }

  queryAsPage() {
    return this.listOrbitLeaderboard()
  }

  async listOrbitLeaderboard() {
    return await Request.get(`/client/orbit-leaderboard`, {
      params: this.params,
    })
      .name('listOrbitLeaderboard')
      .as(this)
      .getResponse()
  }

  async getOrbitLeaderboardSummary(): Promise<OrbitLeaderboardSummary> {
    const raw = await Request.get(`/client/orbit-leaderboard/summary`, {
      params: this.params,
    })
      .name('getOrbitLeaderboardSummary')
      .asAny()
      .getData()

    return Object.assign(new OrbitLeaderboardSummary(), raw)
  }
}
